(function ($) {

    var delayTimer;
    var entities = { result: [], totalMatching: 0 };
    var map;
    var markers;

    var source = $("#entity-template").html();
    var template = Handlebars.compile(source);
    var districts = [];
    var query = "";
    var dynamicFilters = {};
    var filters = {};

    map = initializeMap("entities-map", 58.97, 5.74, 12);

    const markerIcon = L.icon({
        // specify the path here
        iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
        shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png",
        // Uten disse setter Leaflet ingen margin, og ikonets øverste venstre hjørne
        // havner på koordinatet i stedet for nålespissen. Samme mål som standardikonet
        // map.js bruker på entitetssidene.
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41]
    });
    
    // Use received data to bind to view
    function entityShowResult(data) {
        entities.Items = data.Items;
        if (map == null)
            return;

        if (markers != null)
            map.removeLayer(markers);

        markers = L.markerClusterGroup();
        markers.clearLayers();

        $(entities.Items).each(function (index, item) {

            // Uten koordinater ville markøren havnet på 0,0, utenfor Afrika
            if (!item.Latitude || !item.Longitude) {
                return;
            }

            // create the marker
            var marker = L.marker([item.Latitude, item.Longitude], { icon: markerIcon });
            marker.bindPopup('' +
                '<strong><a href="' + item.Url + '">' + item.Name + '</a></strong><br />' +
                '<a href="https://maps.google.com/?daddr=' + item.Latitude + ',' + item.Longitude + '" target="_new" class="external">Se veibeskrivelse</a>'
            );
            markers.addLayer(marker);
        });
        map.addLayer(markers);
        // Treff uten koordinater gir ingen markør, og tomme bounds får Leaflet til å kaste.
        if (markers.getLayers().length) {
            map.fitBounds(markers.getBounds(), { padding: [20, 20] });
        }
        
        var html = template(data);
        $("#entities-result").html(html);
    }

    // Search for string and handle received data
    function entitySearch() {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function () {

            query = $('#search-entity-form .entity-search-input').val();

            filters = {
                districts: districts.join()
            }

            // Update url with query
            if (history.pushState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?q=' + query;

                // Add districts selection
                if (filters.districts.length)
                    newurl = newurl + "&d=" + filters.districts;
                
                var dynamicFiltersBase64 = btoa(JSON.stringify(dynamicFilters));
                
                if(dynamicFilters !== [])
                    newurl = newurl + "&f=" + dynamicFiltersBase64;

                window.history.pushState({ path: newurl }, '', newurl);
            }

            $.getJSON(entityApiUrl, { query: query, districts: filters.districts, dynamicFilters: dynamicFiltersBase64 }, entityShowResult);
        }, 250);
    }   

    // Handle search input text input
    var entitySearchInputTimer;
    $('#search-entity-form .entity-search-input').on('input', function () {
        entitySearch(query, filters);
    });

    // Trigger input event if value is present
    if ($('#search-entity-form .entity-search-input').val() !== '') {
        $("#search-entity-form .entity-search-input").trigger("input");
    }

    // Handle button search
    $('#search-entity-form input[type=submit]').click(function () {
        entitySearch();
    });

    $(".filter-district input[type=checkbox]").change(function () {

        if ($(this).is(":checked")) {
            districts.push($(this).val());
        } else {
            var index = districts.indexOf($(this).val());    // <-- Not supported in <IE9
            if (index !== -1) {
                districts.splice(index, 1);
            }
        }
        
        entitySearch();
    });

    // Search for blank on start
    $(document).ready(function () {

        $('.filter-district input[type=checkbox]').each(function () {
            if ($(this).is(":checked")) {
                districts.push($(this).val());
            } else {
                var index = districts.indexOf($(this).val());    // <-- Not supported in <IE9
                if (index !== -1) {
                    districts.splice(index, 1);
                }
            }
        });

        // Handle dynamic facet filters
        var dynamicFilterRangeElements = document.querySelectorAll("input[type='range'][data-dynamicfilter]");
        var dynamicFilterCheckboxElements = document.querySelectorAll("input[type='checkbox'][data-dynamicfilter]");

        function handleDynamicFilters() {
            dynamicFilters = {};
            
            dynamicFilterRangeElements.forEach(el =>  {
                if(el.getAttribute("max") === el.value)
                    return;
                
                dynamicFilters[el.getAttribute("name")] = el.value   
            });
            dynamicFilterCheckboxElements.forEach(el => { 
                if(!el.checked) 
                    return;
                
                if(!dynamicFilters[el.getAttribute("name")]) 
                    dynamicFilters[el.getAttribute("name")] = el.value;
                
                else dynamicFilters[el.getAttribute("name")] += "|" + el.value
            });
                        
            entitySearch();
        }

        dynamicFilterRangeElements.forEach(el => el.addEventListener('change', () => handleDynamicFilters()));
        dynamicFilterCheckboxElements.forEach(el => el.addEventListener('change', () => handleDynamicFilters()));
        
        handleDynamicFilters();
    });

})(jQuery);
